import React, { useState, useEffect } from "react"
import { withPrefix } from "gatsby"
import { useApplyContext } from "./context"
import html2pdf from "html-to-pdf-js"

const AppTermsModal = () => {
  const {
    showTermsModal,
    setShowTermsModal,
    termsModalContent,
    getTermsModalContent,
  } = useApplyContext()

  const [modalLoading, setModalLoading] = useState(false)

  useEffect(() => {
    if (showTermsModal) {
      getTermsModalContent()
    }
  }, [showTermsModal])

  return showTermsModal && termsModalContent ? (
    <>
      <div className="modal-backdrop fade show"></div>
      <div
        className="modal fade show"
        id="modal-default"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        style={{ display: "block" }}
        aria-modal="true"
      >
        <div
          className="modal-dialog modal-long"
          role="document"
          style={{
            maxWidth: "840px",
          }}
        >
          <div className="modal-content">
            <div className="modal-header align-items-center">
              <h5 className="modal-title">{termsModalContent.title}</h5>
              {termsModalContent.lastUpdate}
            </div>

            <div
              className="modal-body"
              style={{
                height: termsModalContent.heightAuto
                  ? "auto"
                  : "calc(100vh - 280px)",
                overflow: "hidden",
                overflowY: "scroll",
              }}
            >
              {typeof termsModalContent.text === "object" ? (
                termsModalContent.text
              ) : (
                <div
                  dangerouslySetInnerHTML={{
                    __html: termsModalContent.text,
                  }}
                ></div>
              )}
            </div>
            <div className="modal-footer justify-content-center">
              <button
                type="button"
                className="btn btn-xl btn-secondary"
                data-dismiss="modal"
                onClick={() => setShowTermsModal(null)}
              >
                {termsModalContent.closeLabel
                  ? termsModalContent.closeLabel
                  : "Close"}
              </button>
              {!termsModalContent.hidePrint && (
                <a
                  download
                  className="btn btn-xl btn-dark"
                  href={withPrefix(showTermsModal + ".pdf")}
                  target="_blank"
                  // onClick={e => {
                  //   e.stopPropagation()
                  //   html2pdf()
                  //     .set({
                  //       margin: 20,
                  //       pagebreak: {
                  //         mode: ["avoid-all", "css", "legacy"],
                  //       },
                  //       html2canvas: { scale: 1 },
                  //     })
                  //     .from(
                  //       document.getElementsByClassName("modal-body")[0]
                  //         .firstElementChild
                  //     )
                  //     .to("pdf")
                  //     .save()
                  // }}
                >
                  {modalLoading ? "Loading" : "Print"}
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  ) : null
}

export default AppTermsModal
